var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:{ 'app-main__qiankun': true, mini: _vm.device === 'mobile' }},[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{key:_vm.key})],1),_c('div',{attrs:{"id":"app-qiankun"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }